module.exports = __webpack_public_path__ + "img/1488167933.d452ad72.jpg";